/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

import DeleteModal from '../../modals/deleteModal'
import EditModal from '../../modals/editModal'
import EditExpenseModal from './editExpenseModal'

function ExpenseActionButton(props) {
    const [categoryId, setCategoryId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [editModal, setEditModal] = useState(false)

    let handleDelete = () => {
        console.log("Delete Props", props.data)
        props.data.deleteExpense(props.data.psId)
    }

    let handleOpenEdit = (e) => {
        console.log('Props', props)
        setEditModal(true)
    }

    let handleCloseEdit = (e) => {
        setEditModal(false)
    }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        setCategoryId(mainData.id)
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    return (
        <>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            {/* <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button> */}
            <DeleteModal open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} /> 
            <EditModal size="small" open={editModal} onClose={handleCloseEdit}>
                <Modal.Header>Edit Expense</Modal.Header>
                <EditExpenseModal expense={props.data} agGridProps={props.agGridReact.props} handleCloseEdit={handleCloseEdit} updateExpense={props.data.updateExpense} />
            </EditModal>
        </>
    )
}

export default ExpenseActionButton
